/**
 * US/Canada NANP formatting and validation (10-digit national number).
 * NPA (area code) and NXX (exchange) first digits must be 2–9.
 */

export function formatUsPhoneInput(value) {
  let d = String(value).replace(/\D/g, '')
  if (d.length >= 11 && d[0] === '1') d = d.slice(1)
  d = d.slice(0, 10)
  if (d.length === 0) return ''
  if (d.length <= 3) return `(${d}`
  if (d.length <= 6) return `(${d.slice(0, 3)}) ${d.slice(3)}`
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`
}

export function digitsFromUsPhone(value) {
  let d = String(value).replace(/\D/g, '')
  if (d.length === 11 && d[0] === '1') d = d.slice(1)
  return d
}

/**
 * @returns {boolean} true if valid US NANP mobile/landline pattern (10 digits after optional +1)
 */
export function isValidUsPhoneNumber(value) {
  const d = digitsFromUsPhone(value)
  if (d.length !== 10) return false
  const npaFirst = d[0]
  const nxxFirst = d[3]
  if (npaFirst < '2' || npaFirst > '9') return false
  if (nxxFirst < '2' || nxxFirst > '9') return false
  return true
}
